(function () {
  'use strict';

  var ADMIN_URL = 'https://asm-admin-production.up.railway.app';
  var RATES_CACHE_KEY = 'asm_currency_rates';
  var RATES_CACHE_TTL = 6 * 60 * 60 * 1000;

  var COUNTRY_CURRENCY = {
    US: { code: 'USD', symbol: '$',   decimals: 2, name: 'Estados Unidos' },
    CA: { code: 'CAD', symbol: '$',   decimals: 2, name: 'Canadá' },
    GB: { code: 'GBP', symbol: '£',   decimals: 2, name: 'Reino Unido' },
    FR: { code: 'EUR', symbol: '€',   decimals: 2, name: 'Francia' },
    DE: { code: 'EUR', symbol: '€',   decimals: 2, name: 'Alemania' },
    ES: { code: 'EUR', symbol: '€',   decimals: 2, name: 'España' },
    IT: { code: 'EUR', symbol: '€',   decimals: 2, name: 'Italia' },
    BR: { code: 'BRL', symbol: 'R$',  decimals: 2, name: 'Brasil' },
    MX: { code: 'MXN', symbol: '$',   decimals: 2, name: 'México' },
    AR: { code: 'ARS', symbol: '$',   decimals: 0, name: 'Argentina' },
    CL: { code: 'CLP', symbol: '$',   decimals: 0, name: 'Chile' },
    PE: { code: 'PEN', symbol: 'S/',  decimals: 2, name: 'Perú' },
    UY: { code: 'UYU', symbol: '$',   decimals: 2, name: 'Uruguay' },
    PY: { code: 'PYG', symbol: 'Gs.', decimals: 0, name: 'Paraguay' },
    BO: { code: 'BOB', symbol: 'Bs.', decimals: 2, name: 'Bolivia' },
    EC: { code: 'USD', symbol: '$',   decimals: 2, name: 'Ecuador' },
    PA: { code: 'USD', symbol: '$',   decimals: 2, name: 'Panamá' },
    CR: { code: 'CRC', symbol: '₡',   decimals: 0, name: 'Costa Rica' },
    GT: { code: 'GTQ', symbol: 'Q',   decimals: 2, name: 'Guatemala' },
    HN: { code: 'HNL', symbol: 'L',   decimals: 2, name: 'Honduras' },
    NI: { code: 'NIO', symbol: 'C$',  decimals: 2, name: 'Nicaragua' },
  };

  var country  = (window.Shopify && window.Shopify.country) || '';
  var currency = COUNTRY_CURRENCY[country];

  if (!currency) return;

  // ── Cache localStorage ─────────────────────────────────────────────────────

  function getRatesFromCache() {
    try {
      var raw = localStorage.getItem(RATES_CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - data.ts > RATES_CACHE_TTL) return null;
      return data.rates;
    } catch (e) { return null; }
  }

  function saveRatesToCache(rates) {
    try {
      localStorage.setItem(RATES_CACHE_KEY, JSON.stringify({ rates: rates, ts: Date.now() }));
    } catch (e) {}
  }

  // ── Helpers ────────────────────────────────────────────────────────────────

  function parseCOP(text) {
    // "$ 175.000,00 COP" → 175000  (punto=miles, coma=decimal)
    var clean = text.replace(/[^0-9.,]/g, '');
    clean = clean.replace(/,\d+/, '');
    clean = clean.replace(/\./g, '');
    return parseInt(clean, 10) || 0;
  }

  function formatAmount(amount, curr) {
    var rounded = curr.decimals === 0 ? Math.round(amount) : parseFloat(amount.toFixed(curr.decimals));
    var formatted = rounded.toLocaleString('es-CO', {
      minimumFractionDigits: curr.decimals,
      maximumFractionDigits: curr.decimals
    });
    // "USD $ 48.05" — código + símbolo + monto
    return curr.code + ' ' + curr.symbol + ' ' + formatted;
  }

  // ── Selector de país en header ─────────────────────────────────────────────

  function updateLocalizationUI() {
    var btns = document.querySelectorAll('.disclosure__button.localization-form__select');
    btns.forEach(function (btn) {
      var span = btn.querySelector('span');
      if (!span) return;
      if (span.textContent.indexOf('COP') === -1) return;
      // Formato igual al nativo de Shopify: "Colombia | COP $"
      span.textContent = currency.name + ' | ' + currency.code + ' ' + currency.symbol;
    });

  }

  // ── Conversión de precios ──────────────────────────────────────────────────

  function convertElement(el, rate) {
    if (el.dataset.asmConverted) return;
    var cop = parseCOP(el.innerText || el.textContent || '');
    if (!cop) return;
    el.dataset.asmConverted = '1';
    el.dataset.asmCop = cop;
    el.textContent = formatAmount(cop * rate, currency);
  }

  function convertPrices(rates) {
    var rate = rates[currency.code];
    if (!rate) return;

    document.querySelectorAll('.price-item--regular, .price-item--sale, .price-item--last').forEach(function (el) {
      convertElement(el, rate);
    });

    document.querySelectorAll('.ws-price-block__amount').forEach(function (el) {
      convertElement(el, rate);
    });

    document.querySelectorAll('.ws-price-block__savings').forEach(function (el) {
      if (el.dataset.asmConverted) return;
      el.dataset.asmConverted = '1';
      el.textContent = el.textContent.replace(/\$[\d\.,]+/, function (match) {
        var cop = parseCOP(match);
        return cop ? formatAmount(cop * rate, currency) : match;
      });
    });
  }

  // ── Init ───────────────────────────────────────────────────────────────────

  function run(rates) {
    updateLocalizationUI();
    convertPrices(rates);
    setTimeout(function () { convertPrices(rates); }, 1500);
  }

  function init() {
    var cached = getRatesFromCache();
    if (cached) { run(cached); return; }

    fetch(ADMIN_URL + '/api/rates')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.rates) return;
        saveRatesToCache(data.rates);
        run(data.rates);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
